import React from 'react';
import { NodeSpec } from 'prosemirror-model';
import { Plugin } from 'prosemirror-state';

import { addAddMenuBlock } from '@lyearn/lygo-blocks/src/plugins/AddMenu/utils';
import { addAdvanceMenuItem } from '@lyearn/lygo-blocks/src/plugins/AdvancedMenuPlugin/utils';

import { default as BaseExtension } from '../BaseExtension';
import { EditorOptions, PerformanceType } from '../ExtensionManager/types';
import { useReactNodeView } from '../ReactNodeView';
import { createReactExtensionProps } from './types';

type Constructor<T = {}> = new (...args: any[]) => T;

const createReactExtension: (props: createReactExtensionProps) => Constructor<BaseExtension> = (
  props: createReactExtensionProps,
) => {
  let { attrs, Component, name, menuItem, performanceType, advancedMenuItem, content } = props;

  const wrapperReactComponent = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { node, view, updateAttrs } = useReactNodeView();

    return (
      <Component
        attrs={node?.attrs}
        editable={view?.editable}
        editorView={view}
        updateAttribute={updateAttrs}
      />
    );
  };

  return class createReactExtension extends BaseExtension {
    get schema(): NodeSpec {
      return {
        attrs: attrs,
        group: 'block',
        isAtom: true,
        parseDOM: [],
        selectable: false,
        content,
        toDOM: () => {
          return ['div'];
        },
      };
    }

    plugins({ createReactNodeView }: EditorOptions) {
      return [
        new Plugin({
          props: {
            nodeViews: {
              [name]: (node, view, getPos, decorations) => {
                return createReactNodeView({
                  node,
                  view,
                  getPos,
                  decorations,
                  component: wrapperReactComponent,
                });
              },
            },
          },
          view: (editorView) => {
            addAddMenuBlock(editorView, menuItem);
            if (advancedMenuItem) {
              addAdvanceMenuItem(editorView, advancedMenuItem);
            }

            return {};
          },
        }),
      ];
    }

    get name(): string {
      return name;
    }

    get performanceType() {
      return performanceType ?? PerformanceType.SCROLL_BASED;
    }
  };
};

export default createReactExtension;
